/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './alertEvent/alertEvent.js';
import './backup/backup.js';
import './bulkRestore/bulkrestore.js';
import './bulkRestoreCsvVerification/bulkRestoreCsvVerification.js';
import './chatter.tpl.html';
import './export/export.js';
import './metadataCompare/metadataCompare.js';
import './metadataRestore/metadataRestore.js';

angular
  .module('chatter', [
    'ui.router',
    'chatter.alertEvent',
    'chatter.backup',
    'chatter.export',
    'chatter.bulkrestore',
    'chatter.bulkrestorecsvverification',
    'chatter.metadataCompare',
    'chatterMain.metadataRestore',
    'sbsf.constants'
  ])
  .constant('CHATTER_SIZES', {
    API: 340,
    BACKUP: 380,
    EXPORT: 260,
    BULK_RESTORE: 260,
    BULK_RESTORE_CSV_VERIFICATION: 260,
    METADATA_COMPARE: 260,
    METADATA_RESTORE: 260,
    PROGRESS: 112
  })
  // This defines the main abstract main chatter view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider
        .state(VIEW_STATES.CHATTER, {
          abstract: true,
          resolve: {
            appInfo: [
              'httpApp',
              function (httpApp) {
                return httpApp.getAppInfo();
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'chatter/chatter.tpl.html',
              controller: 'ChatterCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.alertEvent view.
        .state(VIEW_STATES.CHATTER_ALERT_EVENT, {
          url: '/chatter/alertEvent/{batchId}',
          resolve: {
            eventList: [
              '$stateParams',
              'httpAlertEvents',
              function ($stateParams, httpAlertEvents) {
                return httpAlertEvents.getEventsForBatch($stateParams.batchId);
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/alertEvent/alertEvent.tpl.html',
              controller: 'ChatterAlertEventCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.backup view.
        .state(VIEW_STATES.CHATTER_BACKUP, {
          url: '/chatter/backup/{batchId}',
          resolve: {
            backupBatch: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                // Load the batch using the httpBatch service.
                return httpBatch.getBatch($stateParams.batchId);
              }
            ],
            dashboardPrefs: [
              'dashboardUtils',
              function (dashboardUtils) {
                return dashboardUtils.getDashboardPreferences();
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/backup/backup.tpl.html',
              controller: 'ChatterBackupCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.export view.
        .state(VIEW_STATES.CHATTER_EXPORT, {
          url: '/chatter/export/{batchId}',
          resolve: {
            exportBatch: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                // Load the batch using the httpBatch service.
                return httpBatch.getBatch($stateParams.batchId);
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/export/export.tpl.html',
              controller: 'ChatterExportCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.bulkRestore view.
        .state(VIEW_STATES.CHATTER_BULK_RESTORE, {
          url: '/chatter/bulkRestore/{batchId}',
          resolve: {
            bulkRestoreBatch: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                // Load the batch using the httpBatch service.
                return httpBatch.getBatch($stateParams.batchId);
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/bulkRestore/bulkrestore.tpl.html',
              controller: 'ChatterBulkRestoreCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.bulkRestore view.
        .state(VIEW_STATES.CHATTER_BULK_RESTORE_CSV_VERIFICATION, {
          url: '/chatter/bulkRestoreCsvVerification/{batchId}',
          resolve: {
            bulkRestoreCsvVerificationBatch: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                // Load the batch using the httpBatch service.
                return httpBatch.getBatch($stateParams.batchId);
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/bulkRestoreCsvVerification/bulkRestoreCsvVerification.tpl.html',
              controller: 'ChatterBulkRestoreCsvVerificationCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.bulkRestore view.
        .state(VIEW_STATES.CHATTER_METADATA_RESTORE, {
          url: '/chatter/metadataRestore/{batchId}',
          resolve: {
            metadataRestoreBatch: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                // Load the batch using the httpBatch service.
                return httpBatch.getBatch($stateParams.batchId);
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/metadataRestore/metadataRestore.tpl.html',
              controller: 'ChatterMetadataRestoreCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        // The views that are rendered in the chatter.metadataCompare view.
        .state(VIEW_STATES.CHATTER_METADATA_COMPARE, {
          url: '/chatter/metadataCompare/{batchId}',
          resolve: {
            metadataCompareBatch: [
              '$stateParams',
              'httpBatch',
              function ($stateParams, httpBatch) {
                // Load the batch using the httpBatch service.
                return httpBatch.getBatch($stateParams.batchId);
              }
            ]
          },
          views: {
            backup: {
              templateUrl: 'chatter/metadataCompare/metadataCompare.tpl.html',
              controller: 'ChatterMetadataCompareCtrl'
            },
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            }
          }
        })
        .state(VIEW_STATES.CHATTER_API, {
          url: '/chatter/api',
          views: {
            backup: {
              templateUrl: 'admin/api/api.tpl.html',
              controller: 'AdminAPICtrl'
            }
          }
        });
    }
  ])
  /**
   * Controller for the abstract chatter view.  It only contains values that are
   * inherited and utilized by it's implementing views.
   */
  .controller('ChatterCtrl', [
    '$scope',
    'appInfo',
    'authFactory',
    'CHATTER_SIZES',
    'VIEW_STATES',
    function ($scope, appInfo, authFactory, CHATTER_SIZES, VIEW_STATES) {
      var stateName = $scope.state.current.name;

      // Used by the progress view to hide the minimize option.
      $scope.showMinimize = false;

      $scope.gotoApp = function (params) {
        var vForcePageName = appInfo.visualForcePage,
          signedReq = authFactory.getSignedRequest(),
          instance,
          namespace,
          url;

        signedReq.then(function (userInfo) {
          instance = userInfo.client.instanceUrl;
          namespace = userInfo.context.application.namespace;

          url = instance + '/apex/' + namespace + '__' + vForcePageName + params;
          $scope.redirectParent(url);
        });
      };

      /**
       * Utility method for redirecting the parent window.
       * @param {String} url - The URL where the parent should be sent.
       */
      $scope.redirectParent = function (url) {
        //we expect to be in the iframe of an iframe
        parent.parent.window.location = url;
      };

      // There is no chatter specific controller for the api view so
      // size the canvas here if entering the api view.
      if (stateName === VIEW_STATES.CHATTER_BACKUP) {
        // For the backup view set the hideExportProgress and hideBulkRestoreProgress property so that if
        // both a backup and export and restore are happening the backup status will be
        // visible in chatter.
        $scope.hideBulkRestoreProgress = true;
        $scope.hideExportProgress = true;
      } else if (stateName === VIEW_STATES.CHATTER_EXPORT) {
        // For the export view set the hideBackupProgress and hideBulkRestoreProgress property so that if
        // both a backup and export and restore are happening the export status will be
        // visible in chatter.
        $scope.hideBackupProgress = true;
        $scope.hideBulkRestoreProgress = true;
      } else if (stateName === VIEW_STATES.CHATTER_BULK_RESTORE) {
        // For the bulk restore view set the hideExportProgress and hideBackupProgress property so that if
        // both a backup and export and restore are happening the bulk restore status will be
        // visible in chatter.
        $scope.hideBackupProgress = true;
        $scope.hideExportProgress = true;
      }
    }
  ]);
